import Link from 'next/link';
import { withRouter } from 'next/router';
import { node, string, shape } from 'prop-types';

const RouterLink = ({ children, href, router }) => {
  const lng = router && router.query && router.query.lng;
  const paramLng = lng ? `lng=${lng}` : '';
  const hrefWithParams = `${href}?${paramLng}`;

  return (
    <Link href={hrefWithParams}>
      <a>{children}</a>
    </Link>
  );
};

RouterLink.propTypes = {
  router: shape({}),
  children: node.isRequired,
  href: string.isRequired,
};

export default withRouter(RouterLink);



// WEBPACK FOOTER //
// components/shared/RouterLink.js